export default {
  LEVELLING_AND_ALIGNMENT: 'LEVELLING_AND_ALIGNMENT',
  SPACE_CLOSURE_RETRACTION: 'SPACE_CLOSURE_RETRACTION',
  FINISHING_AND_DETAILING: 'FINISHING_AND_DETAILING',
} as const
